import API from './apiConfig';

export const postExperienceById = async (formData) => {
    const id = localStorage.getItem("username")
      ? JSON.parse(localStorage.getItem("username"))
      : "0000";
    try {
      const response = await API.post(`/exp/${id}`, formData);
      return response.data;
    } catch (error) {
      console.error(`Error fetching student ${id}:`, error);
      throw error;
    }
  };
  
  export const updateExperienceById = async (formData) => {
    const id = localStorage.getItem("username")
      ? JSON.parse(localStorage.getItem("username"))
      : "0000";
    try {
      const response = await API.put(`/exp/${id}`, formData);
      return response.data;
    } catch (error) {
      console.error(`Error fetching student ${id}:`, error);
      throw error;
    }
  };
  
  export const getExperienceById = async () => {
    const id = localStorage.getItem("username")
      ? JSON.parse(localStorage.getItem("username"))
      : "0000";
    try {
      const response = await API.get(`/exp/${id}`);
      return response.data.data;
    } catch (error) {
      console.error(`Error fetching student ${id}:`, error);
      throw error;
    }
  };
  